module.exports = __webpack_public_path__ + "img/welcome_mainbg.2414651a.png";